"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBreadcrumbs = void 0;
const BreadcrumbsProvider_1 = require("./BreadcrumbsProvider");
const react_1 = require("react");
const useBreadcrumbs = (item) => {
    const { addItem, removeItem } = (0, react_1.useContext)(BreadcrumbsProvider_1.BreadcrumbsContext);
    (0, react_1.useEffect)(() => {
        const key = item.key ? item.key : item.to + "|" + item.label;
        const itemValue = { ...item, key };
        if (itemValue)
            addItem(itemValue);
        return () => {
            if (itemValue)
                removeItem(itemValue);
        };
    }, []);
    return;
};
exports.useBreadcrumbs = useBreadcrumbs;
